import type { ReactNode } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

interface GuideSubSectionProps {
  title: string;
  children: ReactNode;
  collapsible?: boolean;
  defaultOpen?: boolean;
}

export function GuideSubSection({ title, children, collapsible, defaultOpen }: GuideSubSectionProps) {
  if (collapsible) {
    return (
      <Accordion type="single" collapsible defaultValue={defaultOpen ? 'item' : undefined}>
        <AccordionItem value="item" className="border-none">
          <AccordionTrigger className="text-sm font-semibold text-slate-800 hover:no-underline py-2">
            {title}
          </AccordionTrigger>
          <AccordionContent>
            <div className="space-y-3 text-sm text-slate-600 leading-relaxed">
              {children}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    );
  }

  return (
    <div>
      <h3 className="text-sm font-semibold text-slate-800 mb-2">{title}</h3>
      <div className="space-y-3 text-sm text-slate-600 leading-relaxed">
        {children}
      </div>
    </div>
  );
}
